import { useApiClient } from '@/api/util/useApiClient.util.ts';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import fileDownload from 'js-file-download';

type Req = {
  adminUserId: string;
  /** First day of the period, YYYY-MM-DD */
  from?: string;
  /** Last day of the period, YYYY-MM-DD */
  to?: string;
};

type Response = void;

type Return = {
  downloadQuizResultsExport: (req: Req) => Promise<Response>;
  isDownloading: boolean;
};

export const useDownloadQuizResultsExport = (): Return => {
  const { adminCandidatesApi } = useApiClient();
  const { isPending, mutateAsync } = useMutation<Response, AxiosError, Req>({
    mutationFn: async req => {
      const response = await adminCandidatesApi.downloadQuizResultsExport(
        req.adminUserId,
        req.from,
        req.to,
        {
          responseType: 'blob',
        },
      );
      const fileName =
        response.headers['content-disposition']?.match(/attachment; filename=(.*)/)?.[1] ??
        'quiz-results-export.xlsx';
      fileDownload(
        response.data,
        fileName,
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      );
    },
  });

  return {
    downloadQuizResultsExport: mutateAsync,
    isDownloading: isPending,
  };
};
